export const USER_SEARCH_CONTEXT = 'users'

export const PRODUCT_SEARCH_CONTEXT = 'products'

export const IN_USER_STORE_CONTEXTS = {
  store: 'store',
  all: 'all'
}

export const CONTEXTS = [{
  label_short: 'Produtos',
  label_long: 'Buscar produtos',
  value: 'products'
}, {
  label_short: 'Lojas',
  label_long: 'Buscar lojas',
  value: 'users'
}, {
  label_short: 'Nessa loja',
  value: 'store'
}, {
  label_short: 'No enjoei',
  value: 'all'
}]
